import * as ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { CompatRouter } from 'react-router-dom-v5-compat'
import { withLDProvider } from 'launchdarkly-react-client-sdk'
import { getLDContextStore } from './utils/LDContextStore'
import { env } from '@edge/env'

import { NxEntry } from './App'

const RouterWrapper = () => {
    return (
        <section>
            {/* <React.StrictMode> for React v18 https://nx.dev/guides/react-18#react-router-v6 */}
            <BrowserRouter>
                <CompatRouter>
                    <NxEntry />
                </CompatRouter>
            </BrowserRouter>
        </section>
    )
}

const LDProviderWrapper = withLDProvider({
    clientSideID: env.REACT_APP_LAUNCHDARKLY_CLIENT_ID,
    context: getLDContextStore(),
    options: {
        bootstrap: 'localStorage',
    },
})(RouterWrapper)

ReactDOM.render(<LDProviderWrapper />, document.getElementById('root') as HTMLElement)
